import React from 'react'

import { IEventData } from 'meta/pages/v4/event'
import { IUserTicketData } from 'meta/pages/v4/ticket'
import { ITypeTicketData } from 'meta/pages/v4/typeticket'
import { IWalletEvent } from 'meta/pages/v4/wallet'

import { useUserTicketData } from 'hooks/useTicket'
import { useTypeTicketData } from 'hooks/useTypeTicket'

import UserExtra from './UserExtra'
import UserExtraSkeleton from './UserExtraSkeleton'

type TicketProps = {
  cod: string
  eventData: IEventData
  walletEventData: IWalletEvent
  idx: number
}

type TypeTicketProps = {
  baseProps: TicketProps
  ticketData: IUserTicketData
}

export type UserExtraProps = {
  baseProps: TicketProps
  ticketData: IUserTicketData
  typeTicketData: ITypeTicketData
}

const UserTicketContainer: React.FC<TicketProps> = (props) => {
  const { cod } = props

  const userTicketData = useUserTicketData({ cod })

  if (!userTicketData) {
    return <UserExtraSkeleton />
  }

  return <TypeTicketContainer baseProps={props} ticketData={userTicketData} />
}

const TypeTicketContainer: React.FC<TypeTicketProps> = (props) => {
  const { ticketData, baseProps } = props

  const typeTicketData = useTypeTicketData({ id: ticketData.typeTicketId })

  if (!typeTicketData) {
    return <UserExtraSkeleton />
  }

  return <UserExtra baseProps={baseProps} ticketData={ticketData} typeTicketData={typeTicketData} />
}

export default UserTicketContainer
